export enum DateFilterId {
  CUSTOM = "custom",
  LAST_DAY = "lastDay",
  LAST_WEEK = "lastWeek",
  LAST_MONTH = "lastMonth",
  LAST_YEAR = "lastYear",
}
